import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Delete Category Field',
  make: (fieldId: string) => ({
    key: [fieldId],
    request: () => async ({ http }) => {
      await http({
        method: 'DELETE',
        route: `/fields/${fieldId}`,
      });
    },
  }),
});
